import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../common/services/auth.service';
import { OWN_ORGANISATIONS_AND_SITES, toastrConfig } from '../app.config';
import { ToastrService } from 'ngx-toastr';
import { OwnOrganisationsAndSites } from '../common/types/common';
import { CommonService } from '../common/services/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  errorMessage: string = '';

  constructor(private formBuilder: FormBuilder,
              private authService: AuthService,
              private router: Router,
              private commonService: CommonService,
              private toastr: ToastrService) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  login() {
    if (this.loginForm.valid) {
      this.authService.login(this.loginForm.value).subscribe({
        next: (response) => {
          this.commonService.getOwnOrganisationsAndSites().subscribe((data: OwnOrganisationsAndSites[]) => {
            localStorage.setItem(OWN_ORGANISATIONS_AND_SITES, JSON.stringify(data));
            this.router.navigate(['/dashboard']);
          })
        },
        error: (err) => this.toastr.error(err.message, "", toastrConfig)
      });
    }
  }
}
